/* App shell, based on planung-frontend's App.module.css: a 2-row grid (header +
   content), with the DS Sidebar rendered `position:fixed` inside a zero-size
   absolute slot. Space for the sidebar is reserved by a left inset (a CSS var so
   header + content stay in sync). Transient hover-expand OVERLAYS the content;
   PINNING the sidebar open (.expanded) widens the inset so the content shifts to
   make room. */
.app {
  --content-inset: calc(var(--side-gutter) + var(--sidebar-width));

  display: grid;
  grid-template-rows: var(--header-height) 1fr;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.app.expanded {
  --content-inset: calc(var(--side-gutter) + var(--sidebar-width-expanded));
}

.sidebar-slot {
  position: absolute;
  width: 0;
  height: 0;
}

.content {
  background: var(--color-background);
  min-height: 0;
  overflow: hidden auto;
}

.container {
  width: 100%;
  height: fit-content;
  margin: 0 auto;
  /* design content top spacing */
  padding-top: 26px;
  padding-right: var(--side-gutter);
  padding-left: var(--content-inset);
  padding-bottom: 60px;
  transition: padding-left var(--sidebar-easing, 0.3s ease-out);
}
